<script>
import NextSelect from 'dashboard/components-next/select/Select.vue';

export default {
  components: {
    NextSelect,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      value: this.selected,
    };
  },
  computed: {
    // The original markup omitted :value on each option, so the bound value was
    // the option's rendered text. Mapping value and label to the same field
    // preserves that exactly.
    selectOptions() {
      return this.options.map(option => ({
        value: option.value,
        label: option.value,
      }));
    },
  },
};
</script>

<template>
  <div>
    <label for="dropdown-select">
      {{ label }}
    </label>
    <NextSelect
      id="dropdown-select"
      v-model="value"
      name="dropdown-select"
      :options="selectOptions"
      full-width
      @change="action(value)"
    />
  </div>
</template>
